var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fields)?_c('ul',_vm._l((_vm.fields),function(field){return _c('Field',_vm._b({key:field.name,attrs:{"response":_vm.response,"next":_vm.next}},'Field',field,false))}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }